// @module SuiteDB.SDBFeatureItems.SDBFeatureItems
define("SuiteDB.SDBFeatureItems.SDBFeatureItems.View", [
  "suitedb_sdbfeatureitems_sdbfeatureitems.tpl",
  "Backbone",
  "ROOM4.CCAWSwiperLoader.swiperDeferred",
  "ROOM4.CCAWSwiperLoader.NsNavPlugin",
], function (
  suitedb_sdbfeatureitems_sdbfeatureitems_tpl,
  Backbone,
  swiperDeferred,
  NsNavPlugin
) {
  "use strict";

  // @class SuiteDB.SDBFeatureItems.SDBFeatureItems.View @extends Backbone.View
  return Backbone.View.extend({
    template: suitedb_sdbfeatureitems_sdbfeatureitems_tpl,

    initialize: function initialize(options) {
      var self = this;
      self.items = [];
      self.swiper = null;

      var url =
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/api/items?fields=itemid,urlcomponent,custitem_sdb_item_hide_price,custitemrs_brand,custitemrs_wheel_finish,custitemrs_model,displayname,onlinecustomerprice_formatted,itemimages_detail,custitemrs_tire_size,custitemrs_p_wheel_size,custitemrs_wheel_bolt_patterns&custitem_sdb_feature_item=T&limit=20";

      $.ajax({
        url: url,
        context: document.body,
        method: "GET",
      }).done(function (res) {
        res.items.forEach(function (element) {
          var confirmImg = "";
          if (element.itemimages_detail) {
            var imageObject = element.itemimages_detail;
            var imageKeys = Object.keys(element.itemimages_detail);
            if (imageKeys.length) {
              while (imageObject && !_.has(imageObject[imageKeys[0]], "url")) {
                imageObject = imageObject[imageKeys[0]];
                imageKeys = Object.keys(imageObject);
              }

              var urls = _.pluck(imageObject, "url");
              if (urls && urls[0]) {
                var urlIndex = 0;
                var urlNumbers = urls[0].match(/\d+/g);
                var urlOrder = urlNumbers[urlNumbers.length - 1];
                _.each(urls, function (element, index) {
                  var numbersInUrl = element.match(/\d+/g);
                  var elementOrder = numbersInUrl[numbersInUrl.length - 1];
                  if (elementOrder < urlOrder) {
                    urlOrder = elementOrder;
                    urlIndex = index;
                  }
                });
                confirmImg = urls[urlIndex];
              }
            }
          }
          var finalUrl = element.urlcomponent
            ? element.urlcomponent
            : "/product/" + element.internalid.toString();
          var price = element.onlinecustomerprice_formatted;
          if (element.custitem_sdb_item_hide_price)
            price = "Contact for pricing";
          self.items.push({
            itemId: element.internalid,
            img: confirmImg,
            displayName: element.displayname,
            url: finalUrl,
            price: price,
            name: element.custitemrs_model,
            brand: element.custitemrs_brand,
            finish: element.custitemrs_wheel_finish,
            tireSize: element.custitemrs_tire_size && element.custitemrs_tire_size === "&nbsp;" ? null : element.custitemrs_tire_size,
            wheelSize: element.custitemrs_p_wheel_size && element.custitemrs_p_wheel_size === "&nbsp;" ? null : element.custitemrs_p_wheel_size,
            boltPattern: element.custitemrs_wheel_bolt_patterns && element.custitemrs_wheel_bolt_patterns === "&nbsp;" ? null : element.custitemrs_wheel_bolt_patterns,
          });
        });

        // Render with carousel structure
        self.render();
      });
    },

    render: function render() {
      var self = this;
      Backbone.View.prototype.render.apply(this, arguments);
      // Initialize Swiper after rendering
      swiperDeferred.then(function (Swiper) {
        self.swiper = new Swiper("#featured-items-section .swiper", {
          // Swiper options here
          modules: [NsNavPlugin],
          spaceBetween: 20,
          loop: true,
          preventClicks: true,
          preventClicksPropagation: true,
          threshold: 5,
          navigation: {
            nextEl: "#featured-items-section .cca-swiper-next",
            prevEl: "#featured-items-section .cca-swiper-prev",
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              autoplay: { delay: 2000 },
            },
            992: {
              slidesPerView: 5,
              slidesPerGroup: 5,
              autoplay: { delay: 5000 },
            },
          },
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          },
        });
      });
    },

    // Cleanup on destroy
    destroy: function destroy() {
      var self = this;
      if (self.swiper) {
        self.swiper.destroy();
      }
      return Backbone.View.prototype.destroy.apply(this, arguments);
    },

    //@method getContext @return SuiteDB.SDBFeatureItems.SDBFeatureItems.View.Context
    getContext: function getContext() {
      return {
        items: this.items,
      };
    },
  });
});
